import { cacheDom } from "../utils/QuerySelectors.js"
import { setOpen, setAddress } from '../apps/store/addressSlice'
import store from '../apps/store/store'

const dom = {}
const qs = {
  email: 'type="email"',
  password: 'type="password"',
  confirmPassword: 'data-confirm-password',
  submit: 'data-submit',
  loginForm: 'action="/account/login"',
  recoverForm: 'action="/account/recover"',
  registerForm: 'action="/account"',
  resetForm: 'action="/account/reset"',
  addressAdd: 'data-address-add', 
  newAddressData: 'data-new-address-data',
}
const qsAll = {
  accountNavs: 'data-account-item',
  accountUrls: 'data-account-url',
  editAddressBtns: 'data-address-edit',
}

const setupForm = (form) => {
  const emailField = form.querySelector(`[${qs.email}]`)
  const emailWrap = emailField ? emailField.closest('.input-wrap') : null
  const passwordField = form.querySelector(`[${qs.password}]`)
  const passwordWrap = passwordField ? passwordField.closest('.input-wrap') : null

  form.querySelector(`[${qs.submit}]`).addEventListener('click', (e) => {
    if(emailWrap && form.querySelector(`[${qs.email}]`).value.trim() == '') {
      e.preventDefault()
      if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
      emailWrap.innerHTML += '<p class="input-error">Cannot be blank</p>'
      emailWrap.querySelector(`[${qs.email}]`).addEventListener('keypress', () => {
        if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
      })
    }
    if(passwordWrap) {
      if(passwordField.value == '') {
        e.preventDefault()
        if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
        passwordWrap.innerHTML += '<p class="input-error">Cannot be blank</p>'
        passwordWrap.querySelector(`[${qs.password}]`).addEventListener('keypress', () => {
          if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
        })
      }

      const confirmPassField = form.querySelector(`[${qs.confirmPassword}]`)
      const confirmPassWrap = confirmPassField ? confirmPassField.closest('.input-wrap') : null
      if(confirmPassField && passwordField.value != confirmPassField.value) {
        e.preventDefault()
        if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
        confirmPassWrap.innerHTML += '<p class="input-error">Passwords don’t match</p>'
        confirmPassWrap.querySelector(`[${qs.confirmPassword}]`).addEventListener('keypress', () => {
          if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
        })
      }
    }
  })
}

export const setupAccount = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.loginForm) setupForm(dom.loginForm)
  if(dom.recoverForm) setupForm(dom.recoverForm)
  if(dom.registerForm) setupForm(dom.registerForm)
  if(dom.resetForm) setupForm(dom.resetForm)
  dom.accountNavs.forEach((accountNav) => {
    accountNav.addEventListener('click', () => {
      dom.accountNavs.forEach((navItem) => {
        if(navItem == accountNav) {
          navItem.closest('li').classList.remove('hover:bg-fore', 'hover:text-back')
          navItem.closest('li').classList.add('bg-fore', 'text-back')
        } else {
          navItem.closest('li').classList.add('hover:bg-fore', 'hover:text-back')
          navItem.closest('li').classList.remove('bg-fore', 'text-back')
        }
      })
    })
  })
  if(dom.addressAdd) {
    dom.addressAdd.addEventListener('click', (e) => {
      store.dispatch(setAddress(JSON.parse(dom.newAddressData.innerHTML)))
      store.dispatch(setOpen(true))
    })
  }
  dom.editAddressBtns.forEach((editAddress) => {
    editAddress.addEventListener('click', (e) => {
      store.dispatch(setAddress(JSON.parse(e.target.closest('[data-address]').querySelector('[data-edit-address-data]').innerHTML)))
      store.dispatch(setOpen(true))
    })
  })
  dom.accountUrls.forEach((accountUrl) => {
    const navUrl = accountUrl.dataset.accountUrl
    const pathName = location.href.split('?')[0].replace(location.origin, '') 
    if(typeof navUrl != 'undefined' && navUrl) {
      if(navUrl == pathName) {
        accountUrl.classList.add('bg-fore', 'text-back')
        accountUrl.classList.remove('hover:bg-fore', 'hover:text-back')
      } else {
        accountUrl.classList.remove('bg-fore', 'text-back')
        accountUrl.classList.add('hover:bg-fore', 'hover:text-back')
      }
    }
  })
}